<template>
  <div class="lucky-wheel">
    <div class="wheel-main">
      <div
        v-if="showPointer"
        @click="play"
      >
        <slot name="pointer">
          <div
            class="wheel-pointer"
          ></div>
        </slot>
      </div>
      <div
        id="luckyWheel"
        class="wheel-bg"
        :style="rotateStyle"
      >
        <div class="prize-list">
          <div
            v-for="(item, i) in prizeList"
            :key="i"
            class="prize-item"
            :style="item.style"
          >
            <div
              :style="rotate?item.childStyle:null"
              @click="clickItem(item)"
            >
              <slot
                name="prize"
                :item="item"
                :index="i"
              >
                <div class="prize-pic">
                  <img :src="item.icon" />
                </div>
                <div class="prize-type">
                  {{ item.name }}
                </div>
              </slot>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { RangeLoop } from '@/utils/lottery'
import { props } from '@/utils/lottery-props'
const CIRCLE_ANGLE = 360

export default {
  name: 'RoteTurntable',
  props: {
    ...props,
  },
  data() {
    return {
      prizeList: [], // 奖品列表
      rotateAngle: 0, // 旋转角度
      index: -1, // 奖励索引
      angleList: [], // 每个奖品的角度范围
      isRotating: false, // 是否正在旋转
      rangeLoopInstance: null,
    }
  },

  computed: {
    rotateStyle() {
      return `
        -webkit-transform: rotate(${this.rotateAngle}deg);
        transform: rotate(${this.rotateAngle}deg);`
    },
    average() {
      return CIRCLE_ANGLE / this.prizes.length
    },
  },
  created() {
    // 获取奖品列表
    this.initPrizeList()
  },
  methods: {
    initPrizeList() {
      // 这里可以发起请求，从服务端获取奖品列表
      this.prizeList = this.formatPrizeList(this.prizes)
    },
    // 格式化奖品列表，计算每个奖品的位置
    formatPrizeList(list) {
      // 记录每个奖的位置
      const angleList = []
      const l = list.length
      // 计算单个奖项所占的角度
      const average = CIRCLE_ANGLE / l
      const half = average / 2
      // 循环计算给每个奖项添加style属性
      list.forEach((item, i) => {
        // 每个奖项旋转的位置为 当前 i * 平均值 + 平均值 / 2
        const angle = (i * average + half)
        // 增加 style
        item.style = `-webkit-transform: rotate(${angle}deg); transform: rotate(${angle}deg);`
        if (this.rotate) {
          item.childStyle = `-webkit-transform: rotate(${-angle}deg); transform: rotate(${-angle}deg);`
        }
        // 记录每个奖项的角度范围
        angleList.push(i * average + half)
      })
      this.angleList = angleList
      return list
    },
    play() {
      const { isRotating, animation } = this
      if (isRotating) {
        // 正在旋转的回调
        this.$emit('rotating')
        return
      }
      if (animation) {
        this.isRotating = true
        if (!this.rangeLoopInstance) {
          this.rangeLoopInstance = new RangeLoop({
            range: [0, this.prizes.length], // 转动在1-9之间
            speed: this.speed, // 速度
            factor: this.factor, // 阻尼系数
            loop: this.loop, // pick执行时多转一圈
            watchValue: (value) => {
              this.rotateAngle = Math.floor(value * this.average - this.average / 2)
            },
            endCallback: (val) => {
              //  结束回调
              this.$emit('end', this.prizes[val])
              this.isRotating = false
              this.rangeLoopInstance.reset(false)
            },
          })
        }
        this.isRotating = true
        this.rangeLoopInstance.play()
      }
      this.$emit('start')
    },

    // 停止旋转
    pick(index) {
      if (!this.animation) {
        this.rotateAngle = (this.prizes.length - index) * this.average - this.average / 2
      } else {
        this.rangeLoopInstance.pick(this.prizes.length - index)
      }
    },

    clickItem(item) {
      this.$emit('clickPrize', item)
    },
  },
}
</script>
<style scoped>
  .lucky-wheel {
    width: 100%;
    background-size: 100%;
    padding-top: 20px;
  }
  .wheel-main {
    margin: 0 auto;
    position: relative;
    width: 295px;
    height: 295px;
  }
  .wheel-bg {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    background: url('../../assets/img/draw_wheel.png') no-repeat center top;
    background-size: 100%;
    color: #fff;
  }
  .wheel-pointer {
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 2;
    width: 85px;
    height: 85px;
    background: url('../../assets/img/draw_btn.png') no-repeat center top;
    background-size: 100%;
    transform: translate3d(-50%, -50%, 0);
  }
  .wheel-bg div {
    text-align: center;
  }
  .prize-list {
    width: 100%;
    height: 100%;
    position: relative;
  }
  .prize-list .prize-item {
    position: absolute;
    width: 95px;
    height: 150px;
    top: 0;
    left: 50%;
    margin-left: -47.5px;
    transform-origin: 50% 100%;
  }

  .prize-pic img {
    width: 4.0625rem;
    height: 2.5rem;
    margin-top: 1.5625rem;
  }
</style>
